const formValidator = {
    required: {
        value: true,
        message: 'This field is required!'
    },
    is10DigitPhone: {
        value: /^[0-9]{10}$/,
        message: 'Phone number should have exactly 10 digits!'
    },
    isName: {
        value: /^[a-zA-Z ]*$/,
        message: 'Must not include any special characters or numbers!'
    },
    isEmail: {
        value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        message: 'Invalid email!'
    },
    min: (value: number) => ({
        value,
        message: `Must have a minimum value of ${value}`
    }),
    max: (value: number) => ({
        value,
        message: `This field can have a maximum value of ${value}`
    }),
    maxLength: (value: number) => ({
        value,
        message: `This field can have a maximum ${value} characters`
    }),
    minLength: (value: number) => ({
        value,
        message: `This field must have at least ${value} characters`
    }),
    isAlphaNumeric: {
        value: /^[a-z0-9]+$/i,
        message: 'This field can have only alphabets and numbers!'
    }
}

export default formValidator;